export default __webpack_public_path__ + "static/media/clever-devices.143a30c8.svg";